export default "__VITE_PUBLIC_ASSET__86d15cee__"